module.exports = __webpack_public_path__ + "static/media/Simplify Your.35ab5800.webp";